import {
  shape,
  number,
  arrayOf,
} from 'prop-types';

export const monitoringQueueEntryType = shape({
  id: number.isRequired,
  // action: string.isRequired,
  // message: string.isRequired,
});

export const monitoringQueueEntriesType = arrayOf(monitoringQueueEntryType);


// WEBPACK FOOTER //
// ./src/prop-types/monitoringQueueEntryTypes.js